module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_3016.e7c94de7.png";